/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type GrantPrivacyAuthorizationMutationVariables = {
    appuserId: string;
    reason: string;
    lifetimeDays?: number | null;
};
export type GrantPrivacyAuthorizationMutationResponse = {
    readonly createPrivacyAuthorization: {
        readonly errorMessage: string | null;
        readonly authorization: {
            readonly id: string;
            readonly historyStart: string;
            readonly historyEnd: string;
            readonly notValidAfter: string;
            readonly reason: string;
            readonly grantedBy: string | null;
        } | null;
    } | null;
};
export type GrantPrivacyAuthorizationMutation = {
    readonly response: GrantPrivacyAuthorizationMutationResponse;
    readonly variables: GrantPrivacyAuthorizationMutationVariables;
};



/*
mutation GrantPrivacyAuthorizationMutation(
  $appuserId: ID!
  $reason: String!
  $lifetimeDays: Int
) {
  createPrivacyAuthorization(appuserId: $appuserId, reason: $reason, lifetimeDays: $lifetimeDays) {
    errorMessage
    authorization {
      id
      historyStart
      historyEnd
      notValidAfter
      reason
      grantedBy
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appuserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lifetimeDays"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reason"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appuserId",
        "variableName": "appuserId"
      },
      {
        "kind": "Variable",
        "name": "lifetimeDays",
        "variableName": "lifetimeDays"
      },
      {
        "kind": "Variable",
        "name": "reason",
        "variableName": "reason"
      }
    ],
    "concreteType": "CreatePrivacyAuthorization",
    "kind": "LinkedField",
    "name": "createPrivacyAuthorization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AppDataPrivacyAuthorizationNode",
        "kind": "LinkedField",
        "name": "authorization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "historyStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "historyEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notValidAfter",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "grantedBy",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GrantPrivacyAuthorizationMutation",
    "selections": (v3/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GrantPrivacyAuthorizationMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d598b563f8e359e3c3f9ef31553b83bb",
    "id": null,
    "metadata": {},
    "name": "GrantPrivacyAuthorizationMutation",
    "operationKind": "mutation",
    "text": "mutation GrantPrivacyAuthorizationMutation(\n  $appuserId: ID!\n  $reason: String!\n  $lifetimeDays: Int\n) {\n  createPrivacyAuthorization(appuserId: $appuserId, reason: $reason, lifetimeDays: $lifetimeDays) {\n    errorMessage\n    authorization {\n      id\n      historyStart\n      historyEnd\n      notValidAfter\n      reason\n      grantedBy\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f51fc3a151aab73c958de93367f38cd8';
export default node;
